import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { CartService } from "../../shared/services/cart-service";
import { EitCart } from '../../shared/classes/eitcart';
import { DB, RESPONSE, AppInfo, EitUrl, EitEnv } from '../../shared/services/env.service';
import { TypeOrder, ET_TipoConsegna, ET_TipoOraConsegna } from '../../shared/services/config-app';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../shared/services/api.service';
import { CouponModalComponent } from '../../shared/components/modal/coupon-modal/coupon-modal.component';
import { AuthService } from '../../shared/services/auth.service';

@Component({
	selector: 'app-checkout',
	templateUrl: './checkout.component.html',
	styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

	public checkoutForm: FormGroup;
	public location: any = null;
	public cartData: any = {};
	public typeOrder: any = TypeOrder;
	public tipoConsegna: any = ET_TipoConsegna;
	public tipoOra: any = ET_TipoOraConsegna;
	appInfo: any = AppInfo
  public restaurant: any = {};


	constructor(private router: Router, private fb: FormBuilder, private api: ApiService, private cartService: CartService, 
		private authService: AuthService, private modalService: NgbModal, private toastService: ToastrService, private route: ActivatedRoute) {
		this.cartData = new EitCart();
		this.cartService.cartObs.subscribe(x => {
			this.cartData = x;
		});
		console.log("Checkout ordine");
    this.restaurant = JSON.parse(localStorage.getItem(DB.ACTIVITY_BASE));

		this.checkoutForm = this.fb.group({
			citofono: ['', [Validators.required]],
			interno: ['', [Validators.nullValidator]],
			phone: ['', [Validators.required, Validators.pattern('[0-9]+')]],
			note: ['', [Validators.nullValidator]],
			noteride: ['', Validators.nullValidator],
			terms: new FormControl(true, [Validators.required, Validators.requiredTrue]),
			privacy: new FormControl(true, [Validators.required, Validators.requiredTrue]),
		})

		var loc = JSON.parse(localStorage.getItem(DB.LOCATION));

		if (loc) {
			this.location = loc;
		} else {
			//popup
		}
	}

	ngOnInit(): void {

		if (this.authService.currentUserValue) {
			
			// authorised 
			
		}else{
			//this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

			this.route.queryParams.subscribe(params => {
			console.log(params); 
			if (params && params.token){
				let JWToken = params.token;
				console.log("JWTToken: ", JWToken); 

				var data: any = {};
				data.externaltoken = JWToken;
				this.api.postj("user/security/logingulliver", data, "").subscribe(res => {
				if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK ) {
					this.authService.next(res[RESPONSE.JP_RESULT]);
				}
				});
			}else{
				//invio a login s sito esterno
				let url = EitUrl.apiLoginGulliver + window.location.href; // + EitEnv.baseUrl +"/checkout"; 
				window.open(url,"_self"/*, "_blank"*/);
			}
			});

		}
	}

	onNotify(message: string): void {


		if (message == "gotocart") {
			this.goToPay();
		} else {

		}
	}

	editLocation() {
		this.cartService.editLocation(this.cartData);
	}

	editOrderTime() {
		this.cartService.editOrderTime(this.cartData);
	}

	goToPay() {
		if (!this.cartData.order.orderminverified && this.cartData.order.sovrapprezzononapplicabile) {
			//ordine minimo non verificato!
			var msg = "Attenzione! Ordine minimo di " + this.cartData.order.ordineminimo + "€ in prodotti non raggiunto!";
			this.toastService.error(msg);
		}
		else {
			this.checkoutForm.controls['phone'].setValue(this.checkoutForm.controls["phone"].value.replace(/\s/g, ""));
			let isOrderTimeValid = true, isLocationValid = false, formValid = false;

			//l'orario deve essere controllato sia per ASPORTO che DOMICILIO	
			if (this.cartData.order.tipooraconsegna == 0 /*orario*/) {
				//controllo order_date	      
				console.log("Booking_date:" + this.cartData.order.bookingdate);
				if (this.cartData.order.order_date == "-2") {
					isOrderTimeValid = false;
					/* var msg = "Attenzione! Selezionare un giorno o un orario valido!"
					this.toastService.error(msg); */
					this.editOrderTime();
				}
				else {
					//this.cartData.order.order_date	
					let orario = this.cartData.order.order_date;
					var hmArray = orario.split(":");
					let ore = "";
					let minuti = "";

					if (hmArray.length == 2) {
						ore = hmArray[0];
						minuti = hmArray[1];
					}

					let dateToBeCheckOut = new Date(this.cartData.order.bookingdate);
					dateToBeCheckOut = new Date(dateToBeCheckOut.getFullYear(), dateToBeCheckOut.getMonth(), dateToBeCheckOut.getDate(), +ore, +minuti); //col + cast string==>number

					let today = new Date();
					//var today = new Date( new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
					let differenza = (dateToBeCheckOut.getTime() - today.getTime()) / 1000 / 60; //millisecondi -> secondi -> minuti
					console.log("Differenza: " + differenza);
					if ((dateToBeCheckOut < today) && (((differenza > 0) && (differenza < 20)) || (differenza <= 0))) {
						isOrderTimeValid = false;
						/* msg = "Attenzione! Selezionare un giorno o un orario valido!";
						this.toastService.error(msg); */
						this.editOrderTime();
					}
				}
			}
			else {
				//controllo la fascia oraria
				if (this.cartData.order.fasciaoraria == "-2") {
					isOrderTimeValid = false;
					/* var msg = "Attenzione! Selezionare un giorno o un orario valido!"
					this.toastService.error(msg); */
					this.editOrderTime();
				}
			}

			if (this.cartData.order.type_order == this.typeOrder.REST_ASPORTO) {
				//per l'asporto serve solo il telefono...	
				this.checkoutForm.controls['phone'].updateValueAndValidity();
				this.checkoutForm.controls['phone'].markAllAsTouched();
				formValid = this.checkoutForm.controls['phone'].valid && this.checkoutForm.controls['terms'].valid && this.checkoutForm.controls['privacy'].valid;

				if (formValid && isOrderTimeValid) {
					this.cartData.order.note = this.checkoutForm.controls["note"].value;
					this.cartData.note = this.checkoutForm.controls["note"].value;
					this.cartData.order.phone = this.checkoutForm.controls["phone"].value;
					this.cartService.postCart(this.cartData);
					this.router.navigate(['/checkpay'], { queryParams: {} });
				}
				else {
					var msg = "";
					if (!this.checkoutForm.controls['phone'].valid) msg = "Attenzione! Controllare i dati inseriti!";
					else if (!this.checkoutForm.controls['terms'].valid && !this.checkoutForm.controls['privacy'].valid)
						msg = "Attenzione! Devi leggere ed accettare le Condizioni generali di uso e l'Informativa privacy!";
					else if (!this.checkoutForm.controls['terms'].valid) msg = "Attenzione! Devi leggere ed accettare le Condizioni generali di uso!";
					else if (!this.checkoutForm.controls['privacy'].valid) msg = "Attenzione! Devi leggere ed accettare l'Informativa privacy!";
					else if(!isOrderTimeValid) msg = "Attenzione! Selezionare un giorno o un orario valido!"
					this.toastService.error(msg);
				}
			}
			else {
				let data = {
					rest_id: this.cartData.order.restaurant_id,
					zipcode: this.cartData.order.location.zip,
					order_id: this.cartData.order.id,
					locality: this.cartData.order.location.townstr,
					latitude: this.cartData.order.location.latitudine,
					longitude: this.cartData.order.location.longitudine
				};
				this.api.postj_T("cart/checkaddress", data, "").subscribe(res => {
					if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK) {
						this.checkoutForm.updateValueAndValidity();
						this.checkoutForm.markAllAsTouched();
						formValid = this.checkoutForm.valid;
						isLocationValid = formValid;
						if (isLocationValid && isOrderTimeValid) {

							this.cartData.order.location.citofono = this.checkoutForm.controls["citofono"].value;
							this.cartData.order.location.interno = this.checkoutForm.controls["interno"].value;
							this.cartData.order.note = this.checkoutForm.controls["note"].value;
							this.cartData.order.noteride = this.checkoutForm.controls["noteride"].value;
							this.cartData.note = this.checkoutForm.controls["note"].value;
							this.cartData.noteride = this.checkoutForm.controls["noteride"].value;
							this.cartData.order.phone = this.checkoutForm.controls["phone"].value;
							localStorage.setItem("noteride", JSON.stringify(this.cartData.noteride));
							this.cartService.postCart(this.cartData);

							this.router.navigate(['/checkpay'], { queryParams: {} });
						} else {
							this.toastService.error("Attenzione! Controllare i dati inseriti!");

							var msg = "";
							if (!this.checkoutForm.controls['terms'].valid && !this.checkoutForm.controls['privacy'].valid)
								msg = "Attenzione! Devi leggere ed accettare le Condizioni generali di uso e l'Informativa privacy!";
							else if (!this.checkoutForm.controls['terms'].valid) msg = "Attenzione! Devi leggere ed accettare le Condizioni generali di uso!";
							else if (!this.checkoutForm.controls['privacy'].valid) msg = "Attenzione! Devi leggere ed accettare l'Informativa privacy!";
							if (msg.length) this.toastService.error(msg);
						}
					}
					else {
						this.toastService.error("Il ristorante non consegna all'indirizzo indicato!");
					}
				});

			}
		}

	}



	opencouponmodal() {
		console.log("Inserisci coupon");
		var order: any;
		order = this.cartData.order;
		let modal = this.modalService.open(CouponModalComponent, { size: 'md', centered: true, ariaLabelledBy: 'Coupon-Modal', windowClass: 'coupon-modal' })
		modal.componentInstance.order = order
		modal.componentInstance.init()
		modal.componentInstance.onDismiss.subscribe((event: any) => {
			if (event.status == RESPONSE.JPS_OK) {
				console.log("dismiss datetime response OK");
				//this.cartData.order.order_date = event.orario;
				//this.cartService.loadCart(this.cartData.order.id);
			} else {
				console.log("dismiss datetime response ERROR");
				//this.cartService.loadCart(this.cartData.order.id);
			}
		})
	}
}
